import { unionBy } from 'lodash';
import { getPaginationFromMeta } from '../utils/commonFunctions';

export const GET_SCAN_LIST_PENDING = 'GET_SCAN_LIST_PENDING';
export const GET_SCAN_LIST_REJECTED = 'GET_SCAN_LIST_REJECTED';
export const GET_SCAN_LIST_FETCHED = 'GET_SCAN_LIST_FETCHED';
export const GET_SCAN_PENDING = 'GET_SCAN_PENDING';
export const GET_SCAN_REJECTED = 'GET_SCAN_REJECTED';
export const GET_SCAN_FETCHED = 'GET_SCAN_FETCHED';
export const PATCH_REVERSE_SCAN_PENDING = 'PATCH_REVERSE_SCAN_PENDING';
export const PATCH_REVERSE_SCAN_REJECTED = 'PATCH_REVERSE_SCAN_REJECTED';
export const PATCH_REVERSE_SCAN_FULFILLED = 'PATCH_REVERSE_SCAN_FULFILLED';
export const GET_DAMAGED_BARCODE_SUBMISSION_LIST_PENDING = 'GET_DAMAGED_BARCODE_SUBMISSION_LIST_PENDING';
export const GET_DAMAGED_BARCODE_SUBMISSION_LIST_REJECTED = 'GET_DAMAGED_BARCODE_SUBMISSION_LIST_REJECTED';
export const GET_DAMAGED_BARCODE_SUBMISSION_LIST_FETCHED = 'GET_DAMAGED_BARCODE_SUBMISSION_LIST_FETCHED';
export const GET_SCAN_OVERRIDE_LIST_PENDING = 'GET_SCAN_OVERRIDE_LIST_PENDING';
export const GET_SCAN_OVERRIDE_LIST_REJECTED = 'GET_SCAN_OVERRIDE_LIST_REJECTED';
export const GET_SCAN_OVERRIDE_LIST_FETCHED = 'GET_SCAN_OVERRIDE_LIST_FETCHED';
export const PATCH_DECLINE_SCAN_OVERRIDE_PENDING = 'PATCH_DECLINE_SCAN_OVERRIDE_PENDING';
export const PATCH_DECLINE_SCAN_OVERRIDE_REJECTED = 'PATCH_DECLINE_SCAN_OVERRIDE_REJECTED';
export const PATCH_DECLINE_SCAN_OVERRIDE_FULFULLED = 'PATCH_DECLINE_SCAN_OVERRIDE_FULFULLED';
export const APPROVE_SCAN_OVERRIDE_PENDING = 'APPROVE_SCAN_OVERRIDE_PENDING';
export const APPROVE_SCAN_OVERRIDE_REJECTED = 'APPROVE_SCAN_OVERRIDE_REJECTED';
export const APPROVE_SCAN_OVERRIDE_FULFILLED = 'APPROVE_SCAN_OVERRIDE_FULFILLED';

export default function scans(
  state = {
    scans: [],
    fetching: false,
    fetched: false,
    meta: {
      failReasons: [],
      overrideRequestStatuses: [],
    },
    paging: {
      number: 1,
      size: 20
    },
    scannerCode: {},
    errors: {}
  },
  action
) {
  switch (action.type) {
    case GET_SCAN_LIST_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_SCAN_LIST_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        scans: action.payload.data,
        meta: action.payload.meta,
        paging: getPaginationFromMeta(state.paging, state.paging, action.payload.links)
      };
    }
    case GET_SCAN_LIST_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_SCAN_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_SCAN_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        scannerCode: action.payload.data
      };
    }
    case GET_SCAN_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case PATCH_REVERSE_SCAN_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case PATCH_REVERSE_SCAN_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        scannerCode: action.payload.data
      };
    }
    case PATCH_REVERSE_SCAN_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_DAMAGED_BARCODE_SUBMISSION_LIST_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_DAMAGED_BARCODE_SUBMISSION_LIST_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        scans: action.payload.data,
        meta: action.payload.meta,
        paging: getPaginationFromMeta(state.paging, state.paging, action.payload.links)
      };
    }
    case GET_DAMAGED_BARCODE_SUBMISSION_LIST_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_SCAN_OVERRIDE_LIST_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_SCAN_OVERRIDE_LIST_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        scans: action.payload.data,
        meta: action.payload.meta,
        paging: getPaginationFromMeta(state.paging, state.paging, action.payload.links)
      };
    }
    case GET_SCAN_OVERRIDE_LIST_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case PATCH_DECLINE_SCAN_OVERRIDE_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case PATCH_DECLINE_SCAN_OVERRIDE_FULFULLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        scans: state.scans.map(scan => (scan.id === action.payload.data.id ? action.payload.data : scan))
      };
    }
    case PATCH_DECLINE_SCAN_OVERRIDE_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case APPROVE_SCAN_OVERRIDE_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case APPROVE_SCAN_OVERRIDE_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        scans: unionBy([action.payload.data], state.scans, 'id')
      };
    }
    case APPROVE_SCAN_OVERRIDE_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scansReducer.js